import 'vendor/modernizr';

angular.module('memberPortal').directive('nativeDatepicker', ["$state", function($state) {
  return {
    restrict: 'E',
    template: require('templates/member_portal/native_datepicker.html.slim'),
    scope: {
      model: '=',
      minDate: '=',
      maxDate: '=',
      displayFormat: '@',
      name: '@',
      elementId: '@',
      onChange: '&'
    },
    controller: ["$scope", function($scope) {
      $scope.dateInputSupported = window.Modernizr.inputtypes.date;
      $scope.displayFormat = $scope.displayFormat || 'dd MMM yyyy';
      $scope.onDateChange = function(value) {
        return $scope.onChange({
          value: value
        });
      };
      return $scope.printDay = function(date) {
        return moment(new Date(date)).format($scope.displayFormat);
      };
    }]
  };
}]);
